import {isObject} from '../../lib/helpers';
import {X1Language, X2AgeCategory, X3Level, X4Unit, X5Lesson, X6Page} from '../models/content';

function x1Path(x: X1Language) {
  return x.Name;
}

function x2Path(x: X2AgeCategory): string {
  if (x.Language === null)
    return x.Name;
  return x1Path(x.Language) + '/' + x.Name;
}

function x3Path(x: X3Level) {
  if (x.AgeCategory === null)
    return x.Name;
  return x2Path(x.AgeCategory) + '/' + x.Name;
}

function x4Path(x: X4Unit) {
  if (x.Level === null)
    return x.Name;
  return x3Path(x.Level) + '/' + x.Name;
}

function x5Path(x: X5Lesson) {
  if (x.Unit === null)
    return x.Name;
  return x4Path(x.Unit) + '/' + x.Name;
}

function x6Path(x: X6Page) {
  if (x.Lesson === null)
    return x.Name;
  return x5Path(x.Lesson) + '/' + x.Name;
}

function fullPath(x: X1Language | X2AgeCategory | X3Level | X4Unit | X5Lesson | X6Page): string {
  if (!isObject(x))
    return 'null';
  if ((x as X1Language).AgeCategories !== undefined)
    return x1Path(x as X1Language);
  if ((x as X2AgeCategory).LanguageId !== undefined)
    return x2Path(x as X2AgeCategory);
  if ((x as X3Level).AgeCategoryId !== undefined)
    return x3Path(x as X3Level);
  if ((x as X4Unit).LevelId !== undefined)
    return x4Path(x as X4Unit);
  if ((x as X5Lesson).UnitId !== undefined)
    return x5Path(x as X5Lesson);
  if ((x as X6Page).LessonId !== undefined)
    return x6Path(x as X6Page);
  return '';
}

class ContentHelperClass {
  readonly fullPath = fullPath;
}

export const contentUtils = new ContentHelperClass();
